const maskUpToLast4Digits = (digits) => {
  if (digits.length < 5) {
    return digits;
  }

  const maskedDigits = new Array(digits.length - 4).fill('*').join('');
  const unmaskedDigits = digits.substring(digits.length - 4);

  return `${maskedDigits}${unmaskedDigits}`;
};

export default maskUpToLast4Digits;
